import scene1Headline from "./scenes/scene-1-0";
import sectionIndicators from "./scenes/section-indicators";
import scene17 from "./scenes/scene-1-7";
import scene2 from "./scenes/scene-2";
import scene3 from "./scenes/scene-3";
import scene4, { scene4ScrollTriggers } from "./scenes/scene-4";

export default function startScrollTimeline(callback: Function) {
  scene1Headline();
  scene17();
  scene2();
  scene3();
  scene4();
  scene4ScrollTriggers();
  // Section indicators need to be initialized last, because their locations
  // depend on the padding added by scrollTriggers for the scenes
  sectionIndicators();
  callback();
}
